/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AqueductNode } from './AqueductNode';
import type { CustomNodeDef } from './CustomNodeDef';
import type { Frame } from './Frame';
import type { OutputBinding } from './OutputBinding';
import type { Portal } from './Portal';
import type { PortalExit } from './PortalExit';
import type { Reroute } from './Reroute';

/**
 * The user-editable graph document that JSON Patches modify directly.
 */
export type GraphProjectContent = {
    resolution?: number;
    normal_format?: GraphProjectContent.normal_format;
    outputs?: Record<string, OutputBinding>;
    output_positions?: (Record<string, Array<number>> | null);
    output_order?: Array<string>;
    output_formats?: Record<string, string>;
    nodes?: Record<string, AqueductNode>;
    frames?: Record<string, Frame>;
    reroutes?: Record<string, Reroute>;
    portals?: Record<string, Portal>;
    portal_exits?: Record<string, PortalExit>;
    custom_nodes?: Record<string, CustomNodeDef>;
};

export namespace GraphProjectContent {

    export enum normal_format {
        OPENGL = 'opengl',
        DIRECTX = 'directx',
    }


}
